<template>
    <n-form
        ref="loginForm"
        name="loginForm"
        method="post"
        action="login"
        v-if="isLogin"
        :model="loginFormValue"
        :rules="loginFormRules"
        @submit.prevent="doLogin($event)">
        <n-form-item label="Логин" path="login">
            <n-input
                placeholder="Почта"
                :passively-activated="true"
                clearable
                v-model:value="loginFormValue.login"
                size="large"
                @keyup.enter="doLogin($event)"></n-input>
        </n-form-item>
        <n-form-item label="Пароль" path="password">
            <n-input
                placeholder="Секретный"
                show-password-on="click"
                type="password"
                clearable
                v-model:value="loginFormValue.password"
                @keyup.enter="doLogin($event)"
                size="large" />
        </n-form-item>
    </n-form>
    <n-button v-if="isLogin" block type="primary" :loading="isLoading" strong size="large" @click="doLogin">
        Войти
    </n-button>
    <div class="sub_form_item_space">
        <a href="#" style="color: rgb(24, 160, 88); text-decoration: none" v-if="isLogin" @click="switchView"
            >Забыли пароль?</a
        >
    </div>

    <n-form
        v-if="!isLogin"
        v-show="!isFinished"
        className="form"
        ref="forgotForm"
        :model="forgotFormValue"
        :rules="forgotFormRules"
        size="large">
        <n-form-item path="email" label="Логин">
            <n-input v-model:value="forgotFormValue.email" size="large" placeholder="Почта" />
        </n-form-item>
        <n-button size="large" block strong :loading="isLoading" secondary type="success" @click="handleSubmitButton">
            Напомнить
        </n-button>
        <n-button class="sub_form_item_space" tag="a" @click="switchView" text href="#" type="primary">Назад</n-button>
    </n-form>
    <n-result size="small" v-if="!isLogin" v-show="isFinished" status="success" title="Новый пароль отправлен на почту">
        <template #footer>
            <n-button tag="a" @click="switchView" text href="#" type="primary">Назад</n-button>
        </template>
    </n-result>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import { useMessage, NInput, NFormItem, NButton, NResult, NForm } from "naive-ui";
import { login } from "@/backend.api";
import authModel from "@/models/authModel";
import { forgot } from "@/backend.api";
import identityResult from "@/models/identityResult";

const message = useMessage();
const forgotForm = ref(null) as any;
const loginForm = ref(null) as any;
let isLoading = ref(false);
let isFinished = ref(false);

const isLogin = ref(true);
const loginFormValue = ref({
    login: "",
    password: ""
});
const forgotFormValue = ref({
    email: ""
});
const loginFormRules = {
    login: {
        required: true,
        message: "Введите почту",
        trigger: ["blur"],
        type: "email"
    },
    password: {
        required: true,
        message: "Введите пароль",
        trigger: ["blur"]
    }
};
const forgotFormRules = {
    email: {
        required: true,
        message: "Введите почту",
        trigger: ["blur"],
        type: "email"
    }
};

const doLogin = (event: Event) => {
    event.preventDefault();
    const form = (loginForm as any).value;

    form.validate(async (errors: any) => {
        if (!errors) {
            isLoading.value = true;
            const signInId: string | null = localStorage.getItem("signinid");

            login(form.model.login, form.model.password, signInId)
                .then((response: any) => {
                    const result = new authModel(response.data);
                    if (result.succeeded) {
                        localStorage.setItem("user", JSON.stringify(response.data));
                        if (response.data.signInId) {
                            localStorage.setItem("signinid", response.data.signInId);
                        }

                        window.location.href = result.redirectPage;
                    } else {
                        message.error(result.getDescriptions());
                    }
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }
    });
};

const handleSubmitButton = (e: any) => {
    e.preventDefault();
    const form = (forgotForm as any).value;
    form.validate(async (errors: any) => {
        if (!errors) {
            isLoading.value = true;
            const promise = forgot(form.model.email);
            promise
                .then((response) => {
                    const result = new identityResult(response.data);
                    if (result.succeeded) {
                        isFinished.value = true;
                    } else {
                        result.getDescriptions();
                        message.error(result.getDescriptions());
                    }
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }
    });
};

const switchView = () => {
    isLogin.value = !isLogin.value;
    isFinished.value = false;
    forgotFormValue.value.email = "";
};
</script>

<style scoped>
.main {
    display: grid;
    place-items: center;
    justify-content: center;
}

.sub_form_item_space {
    margin-top: 20px;
    text-align: right;
}
</style>
